// Lib
import { createAction } from 'redux-actions';

export const AddPost = createAction('ADD_POST');
export const GetPost = createAction('GET_POST');
export const SetPost = createAction('SET_POST');
export const UpdatePost = createAction('UPDATE_POST');

export const CreatePost = createAction('CREATE_POST');
export const EditPost = createAction('EDIT_POST');
export const ClearPosts = createAction('CLEAR_POSTS');
